module.exports = __webpack_public_path__ + "static/img/insurer_bg.6ebdd8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/programme/images/insurer_bg.png
// module id = IElG
// module chunks = 1